import { KnownIssues } from "./KnownIssues";

export const AllKnownIssues = () => <KnownIssues isAllowedToModify />;
